import { getPermissions, addPermission, deletePermission, editPermission, getAPermission} from "@/services/endpoints/permissions";
import { getPermissionUnits} from "@/services/endpoints/permissionUnits";
import { getPermissionRooms} from "@/services/endpoints/permissionRooms";
import { getPermissionGroups, addPermissionGroups, deletePermissionGroup, getAPermissionGroup, editPermissionGroups } from "@/services/endpoints/permissionGroups";

export default {

  async getPermissions({ commit }) {
    try {
      let res = await getPermissions();
      if (res) {
        commit("SET_PERMISSIONS", res.data);
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async getPermissionGroups({ commit }) {
    try {
      let res = await getPermissionGroups();
      if (res) {
        commit("SET_PERMISSION_GROUPS", res.data);
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async getPermissionUnits({ commit }) {
    try {
      let res = await getPermissionUnits();
      if (res) {
        commit("SET_PERMISSION_UNITS", res.data);
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async getPermissionRooms({ commit }) {
    try {
      let res = await getPermissionRooms();
      if (res) {
        commit("SET_PERMISSION_ROOMS", res.data);
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async getAPermissionGroup({ commit }, groupId) {
    try {
      let res = await getAPermissionGroup(groupId);
      if (res) {
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async getAPermission({ commit }, permissionId) {
    try {
      let res = await getAPermission(permissionId);
      if (res) {
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async addPermission({ commit },permission) {
    try {
      let res = await addPermission(permission);
      if (res) {
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async addPermissionGroups({ commit },group) {
    try {
      let res = await addPermissionGroups(group);
      if (res) {
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async editPermissionGroup({ commit },payload) {
    try {
      let res = await editPermissionGroups(payload.group, payload.id);
      if (res) {
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async editPermission({ commit },payload) {
    try {
      let res = await editPermission(payload.permission, payload.id);
      if (res) {
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async deletePermission({ commit },permission) {
    try {
      let res = await deletePermission(permission);
      if (res) {
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async deletePermissionGroup({ commit },permission) {
    try {
      let res = await deletePermissionGroup(permission);
      if (res) {
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },

};
